var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',{attrs:{"title":_vm.$t('common.A/B Splitter')}},[_c('CardSection',[_c('BaseNodeProperties',{attrs:{"node":_vm.node,"readonly":_vm.readonly}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }